import { Notification } from "element-ui";
import { PublicSentimentNavigationBar, localforageDialogSocialColumnConfig } from "@/utils/localforage";

/**
 * 应用版本检测初始化函数
 * 在应用启动时执行一次，检测版本变化并处理相关逻辑
 */
const initializeAppVersion = () => {
  
  const currentVersion = process.env.VUE_APP_VERSION || '2.0.10';
  const storedVersion = localStorage.getItem("vueVersion");
  
  // console.log('版本检测初始化:', { currentVersion, storedVersion });
  
  // 如果存在存储的版本且与当前版本不同，说明有版本更新
  if (storedVersion && storedVersion !== currentVersion) {
    // console.log('检测到版本更新:', storedVersion, '->', currentVersion);
    
    // 更新存储的版本号
    localStorage.setItem("vueVersion", currentVersion);
    
    // FIXME 重要更新，因涉及到舆情模块左侧边栏的破坏性改动，新的侧栏已不兼容旧的数据，因此需要清理数据库数据（记录时间：20250606） 👇
    PublicSentimentNavigationBar.clear().then();
    // FIXME 重要更新，因涉及到舆情模块单一贴文自定义列的破坏性改动，新的数据和旧的数据有很大区别，因此需要清理数据库数据（记录时间：20250703） 👇
    localforageDialogSocialColumnConfig.clear().then();
    
    // 特殊页面不显示更新提示
    if (location.pathname === "/chatBotInsertion" || location.pathname === "/chatBotInsertError") {
      // console.log('特殊页面，跳过更新提示');
    } else {
      // 显示更新提示
      Notification({
        title: "应用更新",
        message: "新版本的应用程序已发布，请刷新页面更新",
        type: "success",
        duration: 0,
        showClose: true,
        onClick: () => {
          window.location.reload();
        },
      });
    }
  } else if (!storedVersion) {
    // 首次访问，存储当前版本
    localStorage.setItem("vueVersion", currentVersion);
    // console.log('首次访问，存储版本号:', currentVersion);
  }
};

/**
 * 手动版本检测函数（用于开发调试）
 */
const manualVersionCheck = () => {
  localStorage.removeItem('vueVersion');
  initializeAppVersion();
};

export { initializeAppVersion, manualVersionCheck };
